const getFormComponent = function getFormComponent() {
  return this.$refs[this.ref];
};

export const useFormWithRef = ({ symbolRefDesc = 'editor' } = {}) => ({
  data: () => ({ ref: Symbol(symbolRefDesc) }),
  methods: {
    validateForm() {
      const form = getFormComponent.call(this);
      return !form || form.validate();
    },
    resetFormValidation() {
      const form = getFormComponent.call(this);
      if (form) {
        form.resetValidation();
      }
    },
    resetForm() {
      const form = getFormComponent.call(this);
      if (form) {
        form.reset();
      }
    },
  },
});
